import { CUSTOM_ELEMENTS_REGISTRY } from "../constants/customElements";
import { registerCustomElementRegistry } from "./registerCustomElementRegistry";

export const registerCustomElements = (): void => {
  registerCustomElementRegistry(CUSTOM_ELEMENTS_REGISTRY);
};
